import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { Toolbar } from 'primereact/toolbar';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import moduleService from './module-service';
import BreadcrumbComponent from '../../../../components/Breadcrumb';

const defaultFilters: DataTableFilterMeta = {
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    name: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    'fullName': {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }],
    },
    representative: { value: null, matchMode: FilterMatchMode.IN },
    date: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.DATE_IS }],
    },
    balance: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    status: {
        operator: FilterOperator.OR,
        constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }],
    },
    activity: { value: null, matchMode: FilterMatchMode.BETWEEN },
    verified: { value: null, matchMode: FilterMatchMode.EQUALS },
};

const ModuleList: React.FC = () => {
    const [modules, setModules] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultFilters);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>('');
    const navigate = useNavigate();
    const [clientState, setClientState] = useState<any>(null);

    useEffect(() => {
        const fetchClientState = async () => {
            try {
                const clientStateItem = await moduleService.getClientState();
                setClientState(clientStateItem);
            } catch (error) {
                console.error('Error fetching client state:', error);
            }
        };

        fetchClientState();
    }, []);

    useEffect(() => {
        if (clientState) {
            const fetchModuleList = async () => {
                try {
                    const response = await moduleService.findAll(clientState.facilityCode);
                    setModules(response);
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            };

            fetchModuleList();
        }
    }, [clientState]);



    function handleCreate(): void {
        navigate(`/admin/module-edit`);
    }

    const handleEdit = (module: any) => {

        navigate('/admin/module-edit', {
            state: { module: module },
        });
    };

    const handleView = (module: any) => {

        navigate('/admin/module-view', {
            state: { module: module },
        });

    };

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        let _filters = { ...filters };

        // @ts-ignore
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters(defaultFilters);
        setGlobalFilterValue('');
    }

    const statusTemplate = (rowData: { recordStatus: string }) => {
        return rowData.recordStatus === '1' ? 'Active' : 'Inactive';
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-between">
                {/* <Button type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} /> */}
                <div>
                    {/* <InputIcon className="pi pi-search" /> */}
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </div>
                <div>
                    <Button icon="pi pi-print" severity="danger" style={{ marginRight: '.1em' }} onClick={() => handlePrint()} />
                    <Button label="New" icon="pi pi-plus" style={{ marginRight: '.5em' }} onClick={() => handleCreate()} />
                </div>
            </div>
        );
    };

    const header = renderHeader();

    function handlePrint(): void {
        window.print();
    };

    const actionTemplate = (rowData: any) => (
        <div style={{ display: 'flex', gap: '5px' }}>
            <Button
                label="View"
                icon="pi pi-eye"
                className="p-button-info p-button-sm "
                style={{ padding: '5px 5px', fontSize: '10px' }}
                onClick={() => handleView(rowData)}
            />
            <Button
                label="Edit"
                icon="pi pi-pencil"
                className="p-button-warning p-button-sm "
                style={{ padding: '5px 5px', fontSize: '10px' }}
                onClick={() => handleEdit(rowData)}
            />
        </div>
    );

    return (
        <div className='grid'>
            <div className='col-12'>
                <div className='card-title'>
                    <h5>Module</h5>
                    <BreadcrumbComponent />
                </div>
                <div className='card'>
                    <>
                        <DataTable value={modules} showGridlines scrollable scrollHeight='auto' paginator rows={10} rowsPerPageOptions={[5, 10, 25, 50]}
                            filters={filters} globalFilterFields={['fullDesc', 'moduleId', 'recordStatus', 'departmentCode']} header={header}
                            sortField='modifiedDate' sortOrder={-1} loading={loading}>
                            <Column
                                header="No."
                                style={{ width: '5%' }}
                                body={(_, { rowIndex }) => rowIndex + 1} // Render row number
                            ></Column>
                            <Column field="moduleId" header="Module ID"></Column>
                            <Column field="fullDesc" header="Full Description"></Column>
                            <Column field="orderSeq" header="Order Sequence" ></Column>
                            <Column field="departmentCode" header="Department" ></Column>
                            <Column field="recordStatus" header="Status" body={statusTemplate}></Column>
                            <Column body={actionTemplate} header="Actions" style={{ width: '20%' }} ></Column>
                        </DataTable>
                    </>
                </div>
            </div>
        </div>
    );
};

export default ModuleList;
